import { render, staticRenderFns } from "./ListItemRoom.vue?vue&type=template&id=c1622b7a&"
import script from "./ListItemRoom.vue?vue&type=script&lang=js&"
export * from "./ListItemRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports